import { FC, useCallback, useMemo } from "react";
import { useScope } from "@state/scopeContext.lib";
import { OrganizationMemberClientAccessSource } from "@common/types/organizationMemberClientAccess";
import { Command } from "@vendor/cmdk/cmdk";
import { useWorkspacesList } from "@api/workspace.api";
import { useCommands } from "./useCommands";
import { WorkspaceCommandItem } from "./WorkspaceCommandItem";

interface WorkspacesCommandsListProps {
    groupHeading: string;
}

export const WorkspacesCommandsList: FC<WorkspacesCommandsListProps> = ({
    groupHeading,
}) => {
    const { close: closeCommands } = useCommands();
    const { data: workspaces } = useWorkspacesList({ includeEntities: true });
    const { changeActiveWorkspace } = useScope();

    const handleSelected = useCallback(
        (workspaceId: string) => {
            changeActiveWorkspace(
                workspaceId,
                OrganizationMemberClientAccessSource.SWITCHER,
            );
            closeCommands();
        },
        [changeActiveWorkspace, closeCommands],
    );

    const sortedWorkspaces = useMemo(
        () =>
            workspaces?.toSorted((a, b) => a.name.localeCompare(b.name)) ?? [],
        [workspaces],
    );

    return (
        <Command.Group heading={groupHeading}>
            {sortedWorkspaces?.map((workspace, index) => (
                <WorkspaceCommandItem
                    key={workspace.id}
                    workspace={workspace}
                    index={index}
                    onSelected={() => handleSelected(workspace.id)}
                />
            ))}
        </Command.Group>
    );
};
